import { USER_PRIVACY } from './_constants';
export var hasPrivacyOptOut = function hasPrivacyOptOut() {
  return typeof window.GeneralMills.getGlobalSetting === "function" && (window.GeneralMills.getGlobalSetting(USER_PRIVACY.ANALYTICS_ENABLED) === false || window.GeneralMills.getGlobalSetting(USER_PRIVACY.FUNCTIONAL_ENABLED) === false || window.GeneralMills.getGlobalSetting(USER_PRIVACY.TARGETING_ENABLED) === false);
};
export var onYouTubeIframeAPIReady = function onYouTubeIframeAPIReady() {
  GeneralMills.Youtube.Videos.forEach(function (video) {
    video.player = new YT.Player(video.id, {
      videoId: video.id,
      events: {
        'onStateChange': window.onPlayerStateChange
      },
      playerVars: {
        rel: 0,
        // show related videos from our channel only
        playsinline: 1,
        // iOS inline playback
        mute: 1,
        autoplay: video.autoplay === true ? 1 : 0
      }
    });
  });
};
export var onPlayerStateChange = function onPlayerStateChange(event) {
  var video = GeneralMills.Youtube.Videos.find(function (v) {
    return v.id === event.target.g.id;
  });

  if (event.data === YT.PlayerState.PLAYING && parseInt(event.target.getCurrentTime(), 10) === 0) {
    var eventDetail = {
      EventType: video.hasPlayed ? 'VideoReplay' : 'VideoStart',
      ContentTitle: video.name,
      EventLabel: video.id
    };
    GeneralMills.Analytics && GeneralMills.Analytics.raiseEvent(eventDetail);
    video.hasPlayed = true;
  } else if (event.data === YT.PlayerState.ENDED) {
    var _eventDetail = {
      EventType: 'VideoComplete',
      ContentTitle: video.name,
      EventLabel: video.id
    };
    GeneralMills.Analytics && GeneralMills.Analytics.raiseEvent(_eventDetail);
  }
};